<template>
	<div class="tpl friend-list-wrap">
		<mt-header title="我的好友" fixed>
		  <router-link to="/chats" slot="left">
		    <!--<mt-button icon="back"></mt-button>-->
		  </router-link>
		  <mt-button class="add-friend-btn" @click.native="addFriend()" icon="more" slot="right"></mt-button>
		</mt-header>
		
		<mt-search v-model="searchValue" cancel-text="取消" placeholder="搜索">
			
		</mt-search>
		
		<div class="friend-list">
			<mt-loadmore :top-method="refreshFriendList" :bottom-method="loadMoreFriendList" :auto-fill="false" ref="loadmore">
				<mt-cell v-for="(item,index) in fList" :key="item.uid">
				  <div class="list-item" @click="goToFriendPage(item.uid)">
				  	<div class="item-img">
				  		<img :src="item.avatar"/>
				  		<span class="is-online">
				  			<img v-if="item.is_vip==0" src="../../assets/img/chats/ic_tips_offline@2x.png" alt="" />
				  			<img v-if="item.is_vip==1" src="../../assets/img/chats/ic_tips_online@2x.png" alt="" />
				  		</span>
				  	</div>
				  	<div class="item-text">
				  		<p class="item-name">{{item.nickname}}
				  			<span class="item-sex">
				  				<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
				  				<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
				  			</span>
				  			<span class="is-vip" v-if="item.is_vip==1">
				  				<img src="../../assets/img/common/ic_user_vip@2x.png"/>
				  			</span>
				  		</p>
				  		<p class="item-other">
				  			{{item.age}} | {{item.height}} | {{item.education}} | {{item.annual_income}}
				  		</p>
				  		<p class="item-sig">
				  			{{item.sig}}
				  		</p>
				  	</div>
				  </div>
				</mt-cell>
				<div class="no-content" v-if="fList.length<1">
					<img src="../../assets/img/default/bg_img_noresults@2x.png"/>
					<p>暂无好友，点击右上角按钮添加好友哦~</p>
				</div>
			</mt-loadmore>
			
		</div>
	</div>
</template>

<script>
	export default{
		name:"friend-list",
		data(){
			return{
				uid:"",
				searchValue:"",
				fList:[]
			}
		},
		created(){
			this.uid = this.$store.state.UserId;
			this.$store.commit("changeTabChoosed","chats");
			this.$store.commit("changeTabBarShow",true);
			
			this.getList();
		},
		watch:{
			searchValue(){
				this.getList();
			}
		},
		methods:{
			getList(){
				
				this.$axios({
					url:"Chat/MyFriendList",
					method:"post",
					data:{
						uid:this.uid,
						search:this.searchValue
					}
				})
				.then(res=>{
					console.log(res);
					if(res.data.code==200){
						if(res.data.data.length<1){
							this.$toast({
								message:"没有更多了哦~",
								position:"bottom",
								duration:3000
							})
						}else{
							this.fList = res.data.data;
						}
					}else{
						this.fList = []
					}
				})
				.catch(err=>{
					console.log(err);
					this.$indicator.close();
					this.$toast({
						message:"加载超时，请重试",
						position:"bottom",
						duration:3000
					})
				})
			},
			addFriend(){
				this.$router.push({
					name:"add-friend"
				})
			},
			goToChat(){
				this.$router.push({
					name:"chatting"
				})
			},
			goToFriendPage(id){
				console.log(id);
				this.$router.push({
					name:"my-page-other",
					query:{
						oid:id
					}
				})
			},
			refreshFriendList(){
				this.nowPage = 1;
				this.getList();
				this.$refs.loadmore.onTopLoaded();
			},
			loadMoreFriendList(){
				this.nowPage++;
				
				this.getList();
				this.$refs.loadmore.onBottomLoaded();
			},
		}
	}
</script>

<style scoped>
	.friend-list-wrap{
		padding-top: 5.4rem;
	}
	.add-friend-btn >>>.mint-button-icon{
		width: 1.8rem;
		height: 1.8rem;
		margin-top: 0.3rem;
		background: url(../../assets/img/chats/ic_nav_add_default@2x.png) no-repeat;
		background-size: contain;
		
	}
	.add-friend-btn >>>.mint-button-icon .mintui-more{
		opacity: 0;
	}
	
	.mint-search {
		position: fixed;
		width: 100%;
		top: 2.5rem;
		left: 0;
		z-index: 10;
		height: auto;
	}
	>>>.mint-searchbar {
		background-color: #fff;
		border-bottom: 1px solid #f3f3f3;
	}
	
	>>>.mint-searchbar-inner {
		background: rgba(40, 40, 40, .12);
		border-radius: 1rem;
		padding: 0 0.8rem;
	}
	
	>>>.mint-searchbar-inner .mintui-search {
		color: #7644FA;
		font-size: 1rem;
	}
	
	>>>.mint-searchbar-inner input {
		background: none;
		padding: 0 0.5rem;
	}
	
	>>>.mint-searchbar-cancel{
		color: #7644FA;
		font-size: 0.8rem;
	}
	>>>.mint-cell-value{
		width: 100%;
	}
	
	.friend-list{
		height: calc(100vh - 5.4rem);
    	overflow-y: scroll;
	}
	.list-item{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		border-bottom: 1px solid #f3f3f3;
		padding: 0.5rem 0;
	}
	.list-item .item-img{
		width: 3rem;
	    height: 3rem;
	    overflow: hidden;
	    position: relative;
	    margin: 0.5rem;
	}
	.list-item .item-img>img{
		width: 100%;
		min-height: 3rem;
    	border-radius: 50%;
	}
	.list-item .is-online{
		position: absolute;
	    top: -0.1rem;
	    right: -0.2rem;
	    width: 1rem;
	    height: 1rem;
	    overflow: hidden;
	}
	.list-item .is-online img{
	    width: 100%;
    	display: block;
	}
	.list-item .item-text{
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		padding: 0 0.5rem;
	}
	.list-item .item-name{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
	}
	.list-item .item-name img{
		width: 1.5rem;
	}
	.list-item .item-other{
		font-size: 0.65rem;
		line-height: 1rem;
	}
	.list-item .item-sig{
		font-size: 0.65rem;
		line-height: 1rem;
		color: #4a4a4a;
	}
</style>


// WEBPACK FOOTER //
// src/components/Chats/FriendList.vue